import * as React from 'react';
import { IAgentReviewsSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { LinkWrapper } from '../../common/components/link_wrapper';
import { Avatar } from '../../common/components/avatar';
import { AgentStats } from '../agent_stats';
import * as styles from './agentPreview.css';
import { Tag } from '../../common/components/tag';
import { ArmorIcon } from './armorIcon';
import { mergeStyles } from '@cian/utils';

export interface IAgentPreviewProps {
  link?: string;
  name?: string | null;
  avatar?: string;

  onClick?(): void;

  agentReviews?: IAgentReviewsSchema | null;
  showProTag?: boolean;

  isPrivateBroker?: boolean | null;
  showIsPrivateBroker?: boolean;
  showPhotoBorder?: boolean;
  makeWhiteColor?: boolean;
  isPro: boolean | null;
  hideAgentReviews?: boolean | null;
  proTagClassName?: string;
}

export function AgentPreview(props: IAgentPreviewProps) {
  const {
    avatar = '',
    link,
    name,
    agentReviews,
    onClick,
    isPrivateBroker,
    showProTag,
    showIsPrivateBroker,
    isPro,
    showPhotoBorder,
    makeWhiteColor,
    hideAgentReviews,
    proTagClassName,
  } = props;

  return (
    <div {...mergeStyles(styles['agent-preview'], makeWhiteColor && styles['white-color'])}>
      <LinkWrapper
        href={link}
        target="_blank"
        notRemoveWrapper
        onClick={onClick}
        {...mergeStyles(styles['link'], showPhotoBorder && styles['photo-border'])}
      >
        <Avatar isRoundness url={avatar} className={styles['avatar']} />
      </LinkWrapper>
      <div className={styles['content']}>
        <div className={styles['content_top']}>
          {name && (
            <LinkWrapper href={link} target="_blank" notRemoveWrapper onClick={onClick} className={styles['name']}>
              {name}
            </LinkWrapper>
          )}
          {isPro && showProTag && (
            <div className={styles['pro_tag_container']}>
              <ArmorIcon />
              <Tag {...mergeStyles(styles['tag'], proTagClassName)} title="Профессиональный пользователь">
                Pro
              </Tag>
            </div>
          )}
        </div>

        <div className={styles['bottom_info']}>
          {showIsPrivateBroker && isPrivateBroker && <span className={styles['company_name']}>Частный маклер</span>}
          {!hideAgentReviews && <AgentStats agentReviews={agentReviews} link={link} uniqueKey="agent-preview" />}
        </div>
      </div>
    </div>
  );
}
